import { doc, getDoc, enableNetwork, DocumentSnapshot } from 'firebase/firestore';
import { db } from '@/firebase/config';

/**
 * Read `users/{uid}` with network explicitly enabled and a short retry for
 * transient "client is offline" states (cache/proxy/VPN quirks).
 */
export async function getUsersDocument(uid: string): Promise<DocumentSnapshot> {
  if (!db) {
    throw new Error('Firestore is not initialized');
  }

  await enableNetwork(db);

  const ref = doc(db, 'users', uid);
  const maxAttempts = 3;
  let lastError: unknown;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await getDoc(ref);
    } catch (e: unknown) {
      lastError = e;
      const msg = e instanceof Error ? e.message : String(e);
      const looksOffline = msg.includes('offline');
      if (looksOffline && attempt < maxAttempts) {
        await enableNetwork(db);
        await new Promise((r) => setTimeout(r, 250 * attempt));
        continue;
      }
      throw e;
    }
  }

  throw lastError;
}
